import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { DialogActions } from '@e3dc-react/shell/Elements/Dialog/Dialog'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { useWarrantyInfo } from 'src/Libs/installation-details/hooks'
import { UseQueryResult } from '@tanstack/react-query'

export interface UpdateWarrantyDialogProps {
  onClose?: () => void
  installationId?: string
  deviceLinkId?: number
  installationStatementId?: number
  refetchFiles: () => Promise<UseQueryResult> | void
}

const UpdateWarrantyModal: React.FC<UpdateWarrantyDialogProps> = ({
  onClose,
  installationStatementId,
  installationId,
  deviceLinkId,
  refetchFiles,
}) => {
  const { updateWarrantyNote, isUpdatingWarrantyInfo } = useWarrantyInfo(installationId, deviceLinkId, installationStatementId)

  const onSubmit = async (): Promise<void> => {
    await updateWarrantyNote({
      installationId,
      installationStatementId: installationStatementId,
      deviceLinkId,
      data: {},
    })
      .then(() => {
        refetchFiles()
      })
      .finally(() => {
        onClose?.()
      })
  }

  const dialogActions: DialogActions = {
    primary: {
      name: 'common.update',
      onClick: onSubmit,
      isLoading: isUpdatingWarrantyInfo,
    },
    secondary: [
      {
        name: 'common.cancel',
        onClick: () => onClose?.(),
      },
    ],
  }

  return (
    <Dialog title={'system-details.installation-statements.update-warranty.title'} actions={dialogActions} maxWidth="sm" onClose={onClose}>
      <Typography variant="body1" mt={4}>
        {'system-details.installation-statements.update-warranty.description'}
      </Typography>
    </Dialog>
  )
}

export default UpdateWarrantyModal
